import React, {useState, useEffect} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Button,
  Modal,
} from "reactstrap";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'sweetalert/dist/sweetalert.css';

import FormCadastroTabloide from './FormCadastroTabloide';
import useToggle from 'lib/useToggle';
import Loading from 'lib/loading'
import settings from 'settings';
import rotas from 'services/rotas';
import rest from 'lib/rest';
import {convertDate} from 'lib/dateUtils'

const Tabloide2 = () => {

  const { SearchBar }                       = Search;
  const [tabloide_id, setTabloide_id]       = useState(0);
  const [modal, setModal]                   = useToggle(false);
  const [loading, setLoading]               = useState(true);
  const [data, setData]                     = useState([]);
  const [refresh,setRefresh]                = useState(0);
  const [totalPaginacao, setTotalPaginacao] = useState(1);
  const [pagina, setPagina]                 = useState(1);
  
  const colunas = [
    {
      dataField: 'tabloid_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'tabloid',
      text: 'Tablóide',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'inicio_promocao',
      text: 'Inicio',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {
        return (convertDate(row.inicio_promocao))
      }
    },
    {
      dataField: 'termino_promocao',
      text: 'Fim',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {
        return (convertDate(row.termino_promocao))
      }
    },
    {
      dataField: 'estado',
      text: 'Estado',
      headerStyle: { cursor: 'default' }
     }
     //,
    // {
    //   dataField: 'ativo',
    //   text: 'Ativo',
    //   headerStyle: { cursor: 'default' }
    // }
  ]

  const abreModal = (id) => {
    setTabloide_id(id);
    setRefresh(refresh+1);
    setModal();
  }

  const fechaModal = (valor) => {
    setRefresh(refresh+1);
    listaTabloides();
    setModal();
  }
  
  useEffect(() => {
    const load = loading;
    // setLoading(false);
    if (load === true) {
      listaTabloides();
    }
  }, [])

  const listaTabloides = ()=>{

    const url     = settings.url + rotas.listarTabloides;
    const retorno = rest.get(url);

    retorno.then(ret => {
      setTotalPaginacao(ret.total);
      setData(ret.retorno)
      setLoading(false);
    })
  }

  const pesquisaTabloide = (type, filtros)=>{
  
    if(type === 'search') {
      const pesquisa = filtros.searchText;      

      if(pesquisa.length >= 3){
        const url   = settings.url + rotas.listarTabloides;
        let retorno = rest.get(url + '?tabloide=' + pesquisa);

        retorno.then(ret => {
          if (ret.success) {
            setTotalPaginacao(1);
            setData(ret.retorno);
            setLoading(false);
            setPagina(1);
          }
        })
      }else if(pesquisa.length === 0){
        //type = 'pagination';
        listaTabloides();
      }
    }

    if(type === 'pagination'){
  
      const pagina  = filtros.page;
      const url     = settings.url + rotas.listarTabloides;
      const retorno = rest.get(url + '?pagina=' + pagina);

      retorno.then(ret => {
        setPagina(filtros.page);
        setData(ret.retorno)
      }) 
    }
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return(
        <div className="content" key="585">
          <Container>
            <Row>
              <Col md="12" className="p-0">
                <Card>

                  <CardHeader>
                    <CardTitle>TABLOIDE</CardTitle>
                  </CardHeader>
                  <CardBody>

                    {/* 
                    <SweetAlert
                      show={this.state.sweet.show}
                      title={this.state.sweet.title}
                      text={this.state.sweet.text}
                      onConfirm={() => this.setState({ sweet: { show: false, title: "", text: "" } })}
                    /> */}

                    <ToolkitProvider
                      search
                      keyField  = "tabloid_id"
                      data      = {data}
                      columns   = {colunas}
                    >
                      {
                        props => (
                          <div>
                            <Container>
                              <Modal
                                key     = 'modalT'
                                size    = 'xl'
                                isOpen  = {modal}
                              >
                                <FormCadastroTabloide
                                  tabloide_id     = {tabloide_id}
                                  recarregaLista  = {listaTabloides}
                                  closeModal      = {fechaModal}
                                  //setValor={this.setvalor.bind(this)}
                                  //insereProduto={() => { this.insereProduto() }}
                                >
                                </FormCadastroTabloide>
                              </Modal>
                              <Row>
                                <Col md="3">
                                  <Button
                                    outline
                                    className = "m-0 w-100"
                                    color     = "primary"
                                    style     = {{ padding: '5px 20px' }}
                                    onClick   = {() => abreModal(0)}
                                  >
                                    <i className="fas fa-plus" />
                                    Cadastrar
                                  </Button>
                                </Col>

                                <Col md="9">
                                  <SearchBar
                                    placeholder = "Buscar Tabloide..."
                                    style       = {{ padding: '5px' }}
                                    {...props.searchProps}
                                  />
                                </Col>
                              </Row>
                            </Container>

                            <hr />

                            <BootstrapTable
                              striped
                              keyField          = 'tabloid_id'
                              remote            = {{ search: true, pagination: true }}
                              data              = {data}
                              columns           = {colunas}
                              noDataIndication  = "Nenhum registro encontrado"
                              pagination        = {paginationFactory({
                                                    page:pagina,
                                                    sizePerPage: 10,
                                                    totalSize: totalPaginacao,
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    showTotal: false,
                                                  })}
                              rowStyle          = {{ cursor: "pointer" }}
                              rowEvents         = {{
                                                    onDoubleClick: (e, row, rowIndex) => {
                                                      abreModal(row.tabloid_id)
                                                      //setModalOpen(true)
                                                    }
                                                  }}
                              onTableChange     = { pesquisaTabloide } 
                              {...props.baseProps}                           
                            />
                          </div>
                        )
                      }
                    </ToolkitProvider>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }
}

export default Tabloide2;